module.exports = __webpack_public_path__ + "static/img/ProximaNovaT-Thin.aa5264b2.svg";